<template>
  <div class="wrapper-general-error">
    <MenuComponent
      logoUrl="assets/logos/LogoBlack.svg"
      textColor="var(--black)"
      menuIcon="assets/icons/MenuBlack.svg"
      closeIcon="assets/icons/CloseBlack.svg"
    />
    <div class="wrapper-page">
      <div class="wrapper-error">
        <img src="assets/icons/404.svg" class="icon" alt="Error 404" />
        <div class="wrapper-text">
          <p class="text">Ups :(</p>
          <p class="text">Parece que la página que estás buscando no existe.</p>
        </div>
        <GenericButton
          text="Volver al inicio"
          backgroundColor="var(--black)"
          textColor="var(--white)"
          shadowType="dark"
          @click="goToHome"
          class="button"
        />
      </div>
      <FooterComponent overlayColor="var(--black)" />
    </div>
  </div>
</template>

<script>
import MenuComponent from "@/ux/layout/components/MenuComponent.vue";
import FooterComponent from "@/ux/layout/components/FooterComponent.vue";
import GenericButton from "../../components/commons/controls/GenericButton.vue";
import { pageNotFoundUse } from "./use/pageNotFoundUse";

export default {
  name: "Error404View",
  components: {
    MenuComponent,
    FooterComponent,
    GenericButton,
  },

  setup() {
    const { goToHome } = pageNotFoundUse();

    return {
      goToHome,
    };
  },
};
</script>

<style scoped lang="scss">
@import "src/ux/pageNotFound/styles/pageNotFoundStyle";
</style>
